<template>
  <div
    :class="[
      'message-input-toolbar',
      !isPC && 'message-input-toolbar-h5',
    ]"
  >
    <div
      :class="[
        'message-input-toolbar-list',
        !isPC && 'message-input-toolbar-h5-list',
      ]"
    >
      <template v-if="props.inputToolbarList === undefined">
        <EmojiPicker
          v-if="isPC"
          ref="emojiPickerRef"
          @insertEmoji="insertEmoji"
          @dialogShowInH5="dialogShowInH5"
          @dialogCloseInH5="dialogCloseInH5"
          @changeToolbarDisplayType="
            (type) => emits('changeToolbarDisplayType', type)
          "
          :isH5EmojiShow="isH5EmojiShow"
          @sendMessage="sendMessage"
        />
        <ImageUpload imageSourceType="album" :isH5ToolShow="isH5ToolShow"/>
        <FileUpload :isH5ToolShow="isH5ToolShow"/>
      </template>
      <template v-else v-for="(item, index) in props.inputToolbarList">
        <EmojiPicker
          v-if="isPC && item.presetId === INPUT_TOOLBAR_TYPE.EMOJI && item.isEnabled === 1"
          ref="emojiPickerRef"
          @insertEmoji="insertEmoji"
          @dialogShowInH5="dialogShowInH5"
          @dialogCloseInH5="dialogCloseInH5"
          @changeToolbarDisplayType="
            (type) => emits('changeToolbarDisplayType', type)
          "
          :isH5EmojiShow="isH5EmojiShow"
          @sendMessage="sendMessage"
        />
        <ImageUpload v-else-if="item.presetId === INPUT_TOOLBAR_TYPE.IMAGE && item.isEnabled === 1" imageSourceType="album" :isH5ToolShow="isH5ToolShow" :title="item.title"/>
        <FileUpload v-else-if="item.presetId === INPUT_TOOLBAR_TYPE.FILE && item.isEnabled === 1" :isH5ToolShow="isH5ToolShow" :title="item.title"/>
        <VideoUpload v-else-if="item.presetId === INPUT_TOOLBAR_TYPE.VIDEO && item.isEnabled === 1" videoSourceType="album" :isH5ToolShow="isH5ToolShow" :title="item.title"/>
        <RatingTool v-else-if="item.presetId === INPUT_TOOLBAR_TYPE.RATING && item.isEnabled === 1 && isInHumanService" :isH5ToolShow="isH5ToolShow" :title="item.title"/>
        <UserDefineTool
          v-else-if="item.isEnabled === 1 && item.isPreset === 0 && item.presetId !== INPUT_TOOLBAR_TYPE.EMOJI"
          :isH5ToolShow="isH5ToolShow"
          :title="item.title"
          :icon="item.icon"
          :type="item.type"
          :content="item.content"
        />
      </template>
    </div>
    <div
      v-if="isH5"
      ref="h5Dialog"
      :class="['message-input-toolbar-h5-dialog']"
    />
  </div>
</template>
<script lang="ts">
import vue from '../../../adapter-vue';
import TUIChatEngine, { IConversationModel, TUIStore, StoreName } from '../../../@aidesk/uikit-engine';
import EmojiPicker from './emoji-picker/index.vue';
import ImageUpload from './image-upload/index.vue';
import FileUpload from './file-upload/index.vue';
import VideoUpload from './video-upload/index.vue';
import RatingTool from './rating-tool/index.vue';
import { isPC, isH5 } from '../../../utils/env';
import { ToolbarDisplayType, InputToolbarModel } from '../../../interface';
import UserDefineTool from './user-define-input-tool.vue';
import { INPUT_TOOLBAR_TYPE } from '../../../constant';
interface IProps {
  displayType: ToolbarDisplayType;
  isH5EmojiShow?: boolean;
  isH5ToolShow?: boolean;
  inputToolbarList?: InputToolbarModel[];
}
interface IEmits {
  (e: 'scrollToLatestMessage'): void;
  (e: 'changeToolbarDisplayType', type: ToolbarDisplayType): void;
  (e: 'insertEmoji', emoji: any): void;
  (e: 'sendMessage'): void;
}
const __sfc_main = {};
__sfc_main.props = {
  displayType: {
    key: "displayType",
    required: false,
    type: null,
    default: 'none'
  },
  isH5EmojiShow: {
    key: "isH5EmojiShow",
    required: false,
    type: Boolean,
    default: false
  },
  isH5ToolShow: {
    key: "isH5ToolShow",
    required: false,
    type: Boolean,
    default: false
  },
  inputToolbarList: {
    key: "inputToolbarList",
    required: false,
    type: Array
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    ref,
    onMounted,
    onUnmounted,
    watch
  } = vue;
  const props = __props;
  const emits = __ctx.emit;
  const h5Dialog = ref<HTMLElement>();
  const currentConversation = ref<IConversationModel>();
  const isGroup = ref<boolean>(false);
  const emojiPickerRef = ref<InstanceType<typeof EmojiPicker>>();
  const isInHumanService = ref(false);
  onMounted(() => {
    TUIStore.watch(StoreName.CONV, {
      currentConversation: onCurrentConversationUpdate
    });
    TUIStore.watch(StoreName.CUSTOM, {
      isInHumanService: onInHumanServiceUpdate
    });
  });
  onUnmounted(() => {
    TUIStore.unwatch(StoreName.CONV, {
      currentConversation: onCurrentConversationUpdate
    });
    TUIStore.unwatch(StoreName.CUSTOM, {
      isInHumanService: onInHumanServiceUpdate
    });
  });
  watch(() => props.displayType, newValue => {
    if (newValue === 'none') {
      emojiPickerRef.value?.closeEmojiPicker();
    } else {
      emits('scrollToLatestMessage');
    }
  });
  watch(() => props.isH5EmojiShow, newValue => {
    if (newValue === false) {
      emojiPickerRef.value?.closeEmojiPicker();
    }
  });
  const onCurrentConversationUpdate = (conversation: IConversationModel) => {
    currentConversation.value = conversation;
    isGroup.value = currentConversation?.value?.type === TUIChatEngine.TYPES.CONV_GROUP;
  };
  const onInHumanServiceUpdate = (data: {
    conversationID: string;
    value: boolean;
  }) => {
    if (data && data.conversationID === currentConversation.value.conversationID) {
      isInHumanService.value = data.value;
    }
  };
  const insertEmoji = (emojiObj: object) => {
    emits('insertEmoji', emojiObj);
  };
  const sendMessage = () => {
    emits('sendMessage');
  };
  const dialogShowInH5 = (dialogDom: any) => {
    if (!isH5) {
      return;
    }
    h5Dialog.value?.appendChild && h5Dialog.value?.appendChild(dialogDom);
  };
  const dialogCloseInH5 = (dialogDom: any) => {
    if (!isH5) {
      return;
    }
    if (dialogDom) {
      h5Dialog.value?.removeChild && h5Dialog.value?.removeChild(dialogDom);
    }
  };
  return {
    isPC,
    isH5,
    INPUT_TOOLBAR_TYPE,
    props,
    emits,
    h5Dialog,
    emojiPickerRef,
    isInHumanService,
    insertEmoji,
    sendMessage,
    dialogShowInH5,
    dialogCloseInH5
  };
};
__sfc_main.components = Object.assign({
  EmojiPicker,
  ImageUpload,
  FileUpload,
  VideoUpload,
  RatingTool,
  UserDefineTool
}, __sfc_main.components);
export default __sfc_main;
</script>
<style lang="scss" scoped>
@import "../style/common";

.message-input-toolbar {
  border-top: 1px solid #f4f5f9;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &-list {
    display: flex;
    flex-direction: row;
    align-items: center;

    .extension-list {
      list-style: none;
      display: flex;

      &-item {
        width: 20px;
        height: 20px;
        padding: 12px 10px 1px;
        cursor: pointer;
      }
    }
  }
}

.message-input-toolbar-h5 {
  padding: 5px 10px;
  box-sizing: border-box;
  flex-direction: column;
}

</style>
